<template>
  <BContainer
    class="p-0 py-2"
    fluid
  >
    <ValidationObserver
      ref="formInformation"
    >
      <form
        role="form"
        novalidate
        @submit.prevent
      >
        <BRow>

          <BCol
            cols="12"
            md="3"
          >
            <BFormGroup
              label="Customer Code"
              label-for="fCustomerCode"
              label-class="font-weight-bolder"
              class="mb-2"
            >
              <BFormInput
                id="fCustomerCode"
                v-model="formInformation.customer_code"
                placeholder="no customer code"
                disabled
              />
            </BFormGroup>
          </BCol>

          <BCol
            cols="12"
            md="9"
          >
            <BFormGroup
              label="Customer Name"
              label-for="fCustomerName"
              label-class="font-weight-bolder"
              class="mb-2"
            >
              <BFormTextarea
                id="fRemarks"
                v-model="formInformation.customer_name"
                rows="2"
                max-rows="4"
                placeholder="no customer name"
                disabled
              />
            </BFormGroup>
          </BCol>

          <BCol
            cols="12"
            md="8"
          >
            <BFormGroup
              label="Customer Name"
              label-for="fCustomerName"
              label-class="font-weight-bolder"
              class="mb-2"
            >
              <BFormInput
                id="fCustomerName"
                v-model="formInformation.customer_name"
                placeholder="no customer name"
                disabled
              />
            </BFormGroup>
          </BCol>

          <BCol
            cols="12"
            class="py-2"
          >
            <div class="border-bottom" />
          </BCol>

          <BCol
            cols="12"
          >
            <BFormGroup
              label="Contact Person"
              label-for="fContactPerson"
              label-class="font-weight-bolder"
              class="mb-2"
            >
              <BFormInput
                id="fContactPerson"
                v-model="formInformation.contact_person"
                placeholder="no contact person"
                disabled
              />
            </BFormGroup>
          </BCol>

          <BCol
            cols="12"
            md="4"
          >
            <BFormGroup
              label="Mobile Number"
              label-for="fMobileNumber"
              label-class="font-weight-bolder"
              description="Only if customer has network coverage"
              class="mb-2"
            >
              <BFormInput
                id="fMobileNumber"
                v-model="formInformation.mobile_number"
                placeholder="no mobile number"
                disabled
              />
            </BFormGroup>
          </BCol>

          <BCol
            cols="12"
            md="8"
          >
            <BFormGroup
              label="Email"
              label-for="fEmail"
              label-class="font-weight-bolder"
              description="Only if customer has an email."
              class="mb-2"
            >
              <BFormInput
                id="fEmail"
                v-model="formInformation.email"
                placeholder="no email"
                type="email"
                disabled
              />
            </BFormGroup>
          </BCol>

          <BCol
            cols="12"
            md="6"
          >
            <BFormGroup
              label="Address"
              label-for="fAddress"
              label-class="font-weight-bolder"
              class="mb-2"
            >
              <BFormTextarea
                id="fAddress"
                v-model="formInformation.address"
                rows="5"
                max-rows="12"
                placeholder="no address"
                disabled
              />
            </BFormGroup>
          </BCol>

          <BCol
            cols="12"
            md="6"
          >
            <BFormGroup
              label="Other Informations"
              label-for="fRemarks"
              label-class="font-weight-bolder"
              class="mb-2"
            >
              <BFormTextarea
                id="fRemarks"
                v-model="formInformation.remarks"
                rows="5"
                max-rows="12"
                placeholder="no other informations"
                disabled
              />
            </BFormGroup>
          </BCol>

        </BRow>
      </form>
    </ValidationObserver>
  </BContainer>
</template>
<script>
import { mapGetters } from 'vuex'

import MxMisc from '@/mixins/misc'

import { SASMCustomer } from '@/services/asm'

export default {
  name: 'VASMCustomerInformations',

  mixins: [
    MxMisc
  ],

  emits: ['updated'],

  data () {
    return {
      flatPickerConfig: {
        appendTo: document.body,
        altInput: true,
        allowInput: true,
        disableMobile: true,
        dateFormat: 'Y-m-d'
      },
      state: {
        busy: false,
        editing: false
      },
      selected: {
        tagging: 1
      },
      fetching: {
        gender: false
      },
      options: {
        gender: ['Male', 'Female'],
        yesOrNos: [
          {
            text: 'No',
            value: '0'
          },
          {
            text: 'Yes',
            value: '1'
          }
        ]
      },
      formInformation: {
        id: '',
        customer_code: '',
        customer_name: '',
        contact_person: '',
        email: '',
        mobile_number: '',
        address: '',
        remarks: '',
        active: 1
      }
    }
  },

  computed: {
    ...mapGetters({
      currentUser: 'auth/user'
    }),

    isVerified () {
      return this.formInformation.status === 'Verified'
    }
  },

  methods: {

    isFetchingLocations () {
      return this.fetching.provinces || this.fetching.municipalities || this.fetching.barangays
    },

    setInformation (customer) {
      this.formInformation = Object.assign(this.formInformation, customer)
    },

    getInformation () {
      return this.formInformation
    },

    async showInformation (customerID) {
      return await SASMCustomer.show(customerID).then(
        ({ data: { customer } }) => customer
      )
    },

    async createInformation () {
      this.state.editing = false

      this.editable.cluster = this.currentUser.cluster

      this.formInformation = Object.assign(this.formInformation, {
        id: '',
        customer_code: '',
        customer_name: '',
        contact_person: '',
        email: '',
        mobile_number: '',
        address: '',
        remarks: '',
        active: 1
      })
    },

    async editInformation (customer) {
      this.state.editing = true

      this.formInformation = Object.assign(this.formInformation, {
        id: customer.id,
        customer_code: customer.customer_code,
        customer_name: customer.customer_name,
        contact_person: customer.contact_person,
        email: customer.email,
        mobile_number: customer.mobile_number,
        address: customer.address,
        remarks: customer.remarks,
        active: customer.active
      })
    },

    async validateInformation () {
      return new Promise((resolve, reject) => {
        this.$refs.formInformation.validate().then(
          isFormValid => {
            if (isFormValid) {
              return resolve(isFormValid)
            }

            return reject(new Error('Invalid Form'))
          }
        )
      })
    },

    async submitInformation () {
      return new Promise(resolve => {
        this.validateInformation().then(
          () => {
            this.swalConfirm({
              html: this.state.editing ? 'Update this Customer?' : 'Register this Customer?',
              confirmButtonText: this.state.editing ? 'Update' : 'Register',
              cancelButtonText: 'Discard',
              preConfirm: async () => {
                this.state.busy = true

                const createOrUpdate = () => {
                  return this.state.editing ? this.putInformation() : this.postInformation()
                }

                return createOrUpdate().catch(
                  ({ message }) => {
                    if (message && message?.errors) {
                      this.$refs.formInformation.setErrors(message?.errors)
                    }
                  }
                ).finally(() => {
                  this.state.busy = false
                })
              }
            }).then(resolve)
          }
        ).catch(() => {
          this.swalInvalid()
        })
      })
    },

    async postInformation () {
      return await SASMCustomer.post(this.formInformation).then(
        ({ data }) => data
      )
    },

    async putInformation () {
      return await SASMCustomer.put(this.formInformation).then(
        ({ data }) => data
      )
    },

    setErrors (errors) {
      if (errors) {
        this.$refs.formInformation.setErrors(errors)
      }
    }
  }
}
</script>
